import React from "react";
import Link from "components/link";
import { ReactComponent as Instagram } from "svgs/instagram.svg";
import { ReactComponent as Facebook } from "svgs/fb.svg";
import { ReactComponent as Pinterest } from "svgs/pinterest.svg";
import { ReactComponent as Tiktok } from "svgs/tiktok.svg";
import { ReactComponent as Youtube } from "svgs/youtube.svg";
import clsx from "clsx/lite";

const data = {
	instagram: { icon: <Instagram className="size-5" />, link: "https://www.instagram.com/modlightingshop/" },
	facebook: { icon: <Facebook className="size-5" />, link: "https://www.facebook.com/shopmodlighting" },
	pinterest: { icon: <Pinterest className="size-5" />, link: "https://www.pinterest.ca/modlighting/" },
	tiktok: { icon: <Tiktok />, link: "https://www.tiktok.com/@modlighting" },
	youtube: { icon: <Youtube />, link: "https://www.youtube.com/channel/UCtOWbPJ_NBHzEn-PEWoSgBA" },
};

const SocialMedia = (
	{ list = ["facebook", "pinterest", "instagram", "tiktok", "youtube"],
		invert = false, className = "flex gap-2" }) => (
	<div className={clsx(className, invert ? "invert" : "invert-0", "flex gap-2")}>
		{list.map((item) => (
			<Link key={item} to={data[item].link} aria-label={item} isTargetBlank>
				{data[item].icon}
			</Link>
		))}
	</div>
);

export default SocialMedia;
